function getExperimentValue() {
  const exp = window.gon?.flags?.experiment_elite_trial_modal;

  if (!exp) {
    return {};
  }

  if (exp.value) {
    return exp.value;
  }

  if (exp.experiment && exp.experiment.value) {
    return exp.experiment.value;
  }

  return exp;
}

async function postTrial() {
  try {
    const response = await fetch('/api/trials', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute('content')
      },
      body: JSON.stringify({})
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      const message = error.error || 'Falha ao ativar trial';
      window.toastr?.error(message);
      return false;
    }

    return true;
  } catch (e) {
    // Network or unexpected errors
    if (e instanceof TypeError) {
      window.toastr?.error(
        'Não foi possível ativar seu trial agora. Tente novamente.'
      );
    } else if (e?.message) {
      window.toastr?.error(e.message);
    } else {
      window.toastr?.error(
        'Não foi possível ativar seu trial agora. Tente novamente.'
      );
    }
    return false;
  }
}

function extractTrialDays(value) {
  const raw = value?.trial_days_by_group ?? '';
  const matched = String(raw).match(/\d+/);
  const parsed = matched ? parseInt(matched[0], 10) : NaN;
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 14;
}

function bindCta() {
  window
    .$(document)
    .off('click', '.js-elite-trial-cta')
    .on('click', '.js-elite-trial-cta', async function () {
      const val = getExperimentValue();
      const link = (val?.link_url || '').trim();
      const days = extractTrialDays(val);

      try {
        const eventName = 'elite trial cta clicked';
        const eventData = {
          flow: link ? 'redirect' : 'activate',
          'trial days': days,
          level: val?.level || 'unlimited_elite',
          'source platform': 'portal',
          'source project': window.gon?.source_project,
          'request path': window.location.pathname
        };

        window.UserTracker?.emit('event', { eventName, data: eventData });
      } catch (_) {
        // no-op
      }

      if (link) {
        window.open(link, '_blank', 'noopener');
        window.$('#js-elite-trial-modal').modal('hide');
        return;
      }

      const ok = await postTrial();

      if (ok) {
        window.$('#js-elite-trial-modal').modal('hide');
        window.toastr?.success(`Trial de ${days} dias ativado com sucesso!`);
      }
    });
}

function hydrateModal() {
  try {
    const val = getExperimentValue();
    const days = extractTrialDays(val);
    const $modal = window.$('#js-elite-trial-modal');

    $modal.find('.js-elite-days').text(days);
    $modal
      .find('.js-elite-title')
      .text(`Experimente o Elite por ${days} dias!`);
    $modal
      .find('.js-elite-subtitle')
      .html(
        `Você está mandando bem! Que tal experimentar o Elite por <span class="js-elite-days">${days}</span> dias?`
      );
    $modal
      .find('.js-elite-cta-text')
      .html(`Liberar <span class="js-elite-days">${days}</span> dias`);
    $modal
      .find('.js-elite-decline-text')
      .html(
        `não quero <span class="js-elite-days">${days}</span> dias do Elite`
      );
  } catch (_) {
    // no-op
  }
}

function exposeApi() {
  window.EliteTrialModal = {
    open: () => {
      hydrateModal();

      if (
        window.ModalManager &&
        typeof window.ModalManager.open === 'function'
      ) {
        window.ModalManager.open('#js-elite-trial-modal');
      } else {
        window.$('#js-elite-trial-modal').modal('show');
      }
    }
  };
}

document.addEventListener('turbolinks:load', () => {
  bindCta();
  exposeApi();
  window
    .$(document)
    .off('show.bs.modal', '#js-elite-trial-modal')
    .on('show.bs.modal', '#js-elite-trial-modal', hydrateModal);
});
